// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

export const PLESK_COOKIES = 'https://docs.plesk.com/en-US/obsidian/cookies';
export const CONTROL_COOKIES = 'https://docs.plesk.com/en-US/obsidian/cookies/#delete-cookies';
